module.exports = "/_next/static/images/OilGas-f7b089d41cb9726a5a59cf1ae4a247c6.webp";